import type { PackageFilterCriteriaOA } from '@openx/types/package';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router';
import { isUrlParamsEqual } from '../../../../utils/isUrlParamsEqual';
import { defaultCriteria } from '../PackagesList/constants';
import { convertCriteriaToSearchParams, getInitialCriteria } from './utils';

type ListSearchParams = {
  packages?: string;
};

export const listSearchParams: ListSearchParams = {};

export const useListCriteria = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateListSearchParams = useCallback((newSearchParams: string) => {
    listSearchParams.packages = newSearchParams;
  }, []);

  const [criteria, setCriteria] = useState<PackageFilterCriteriaOA>(getInitialCriteria(searchParams));

  useEffect(() => {
    if (searchParams.toString() === '') {
      setCriteria(defaultCriteria);
    }
  }, [searchParams]);

  const queryCriteria = useMemo(() => {
    const { filters } = criteria;
    const { phrase } = filters || {};

    return {
      ...criteria,
      filters: {
        ...filters,
        byPhrase: {
          fields: ['name', 'id'],
          phrase: phrase?.trim() || '',
        },
      },
    };
  }, [criteria]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: all necessary dependencies are included
  useEffect(() => {
    const criteriaSearchParams = convertCriteriaToSearchParams(queryCriteria, defaultCriteria);

    if (!isUrlParamsEqual(searchParams, criteriaSearchParams)) {
      setSearchParams(convertCriteriaToSearchParams(queryCriteria, defaultCriteria));
    }
  }, [setSearchParams, updateListSearchParams, queryCriteria, searchParams]);

  return {
    criteria: queryCriteria,
    setCriteria,
  };
};
